import clsx from "clsx";
import { formatPolicyColorToString } from "helper/utils";
import { useMemo } from "react";

import { ColorInput } from "types";
import { defaultFillColor, defaultLineColor, iconColorOptions } from "../policies.const";
import { ColorInputModal } from "./ColorInputModal";
import useToggle from "hooks/use-toggle";

interface PolicyColorInputProps {
  policyColor: ColorInput;
  onSaveColor: (value: ColorInput) => void;
}

export const PolicyColorInput = ({ policyColor, onSaveColor }: PolicyColorInputProps) => {
  const { fillColor, lineColor, dashed, iconColor } = policyColor;
  const [isOpenColorModal, setIsOpenColorModal] = useToggle();

  const textColor = useMemo(() => {
    if (iconColor) {
      return iconColorOptions[iconColor] ?? undefined;
    }
    return undefined;
  }, [iconColor]);

  return (
    <div className="flex gap-4">
      <button
        className={clsx("flex items-center h-5 w-28 border", dashed ? "border-dashed" : "border-solid")}
        style={{
          backgroundColor: formatPolicyColorToString(fillColor ?? defaultFillColor),
          borderColor: formatPolicyColorToString(lineColor ?? defaultLineColor),
        }}
        onClick={setIsOpenColorModal}
        type="button"
      >
        <div className="h-0.5 w-full" />
      </button>
      {iconColor && <span style={{ color: textColor }}>Couleur de l'icône</span>}
      {isOpenColorModal && (
        <ColorInputModal currentColorInput={policyColor} onDismiss={setIsOpenColorModal} onApply={onSaveColor} />
      )}
    </div>
  );
};
